import React from "react";
import { ExternalLink, MapPin, Route, Timer } from "lucide-react";
import {
  GOOGLEMAPS_API_TRAVEL_MODE_BICYCLE,
  GOOGLEMAPS_API_TRAVEL_MODE_CAR,
  GOOGLEMAPS_API_TRAVEL_MODE_TRANSIT,
  GOOGLEMAPS_API_TRAVEL_MODE_WALKING,
  M_URI_PATH,
  ROUTES_URI_PATH,
  RouteViewModel,
  TRANSPORT_TYPE_BICYCLE,
  TRANSPORT_TYPE_CAR,
  TRANSPORT_TYPE_TRANSIT,
  TRANSPORT_TYPE_WALKING
} from "~/src/types/openTypes";
import { Link } from "@remix-run/react";
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton
} from "react-share";

const SHOWCOORDS = false;

function haversine(lat1: number, lon1: number, lat2: number, lon2: number): number {
  const R = 6371; // Радиус Земли в километрах

  const toRad = (value: number) => (value * Math.PI) / 180;

  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
    Math.sin(dLon / 2) ** 2;

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c; // Расстояние в километрах
}

type Props = {
  route: RouteViewModel;
  embedded: boolean
  // defaultValue?: Language | null;
  // onChange?: (lang: Language) => void;
};

function ShareButtons({ route }: Props) {
  const shareUrl = typeof window !== "undefined" ? window.location.origin + ROUTES_URI_PATH + "/" + route.id : ""; // SSR check
  const title = route.name;

  return (
    <div style={{ display: "flex", gap: "8px" }}>
      <FacebookShareButton
        url={shareUrl}
        quote={title}
      >
        <FacebookIcon
          size={32}
          round
        />
      </FacebookShareButton>

      <TwitterShareButton
        url={shareUrl}
        title={title}
      >
        <TwitterIcon
          size={32}
          round
        />
      </TwitterShareButton>

      <LinkedinShareButton
        url={shareUrl}
        title={title}
      >
        <LinkedinIcon
          size={32}
          round
        />
      </LinkedinShareButton>

      <TelegramShareButton
        url={shareUrl}
        title={title}
      >
        <TelegramIcon
          size={32}
          round
        />
      </TelegramShareButton>

      <WhatsappShareButton
        url={shareUrl}
        title={title}
      >
        <WhatsappIcon
          size={32}
          round
        />
      </WhatsappShareButton>

      {/*<VKShareButton url={shareUrl} title={title}>*/}
      {/*  <VKIcon size={32} round />*/}
      {/*</VKShareButton>*/}
    </div>
  );
}

const RouteView = ({
                     route,
                     embedded
                   }: Props) => {
  let googleMapTravelMode = '';

  if (route.request.transportTypes && route.request.transportTypes.length > 0) {
    switch (route.request.transportTypes[0]) {
      case TRANSPORT_TYPE_WALKING:
        googleMapTravelMode = GOOGLEMAPS_API_TRAVEL_MODE_WALKING;
        break;
      case TRANSPORT_TYPE_BICYCLE:
        googleMapTravelMode = GOOGLEMAPS_API_TRAVEL_MODE_BICYCLE;
        break;
      case TRANSPORT_TYPE_CAR:
        googleMapTravelMode = GOOGLEMAPS_API_TRAVEL_MODE_CAR;
        break;
      case TRANSPORT_TYPE_TRANSIT:
        googleMapTravelMode = GOOGLEMAPS_API_TRAVEL_MODE_TRANSIT;
        break;
    }
  }

  const mapUrl = "https://www.google.com/maps/dir/?api=1"
    + "&origin=" + route.places[0].latitude + "," + route.places[0].longitude
    + "&destination=" + route.places[route.places.length - 1].latitude + "," + route.places[route.places.length - 1].longitude
    + "&waypoints=" + route.places.slice(1, -1).map(v => v.latitude + ',' + v.longitude).join("|")
    + "&travelmode=" + googleMapTravelMode;

  return (
    <>
      <div className="space-y-8">
        <div
          // className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm"
          className="bg-white"
        >
          <h1 className="text-3xl font-bold mb-2 text-blue-700">
            {embedded && (

              <Link
                to={`${M_URI_PATH}/routes/${route.id.toString()}`}
                target="_blank"
                className="hover:underline"
              >
                <span>{route.name}</span>
              </Link>
            )}
            {!embedded ? route.name : ''}
          </h1>
          <div className="flex space-x-3 text-sm text-gray-500">
            <div className="flex ">
              <Timer className="w-5 h-5 mr-2" />
              <span>{route.totalDuration}</span>
            </div>
            <div className="flex ">
              <Route className="w-5 h-5 mr-2" />
              <span>{route.totalDistance}</span>
            </div>
            <div className="flex gap-1 guide-route-open-in-google-map">
              <MapPin className="w-5 h-5 mr-0" />
              <a
                className="flex gap-1"
                target="_blank"
                rel="noreferrer"
                href={mapUrl}
              >
                Map
                <ExternalLink className="w-5 h-5" />
              </a>
            </div>
          </div>

          <p className="text-gray-600 mb-6">
            {/*⏱ {actionResult.results[0].output_parsed.totalDuration}, {actionResult.results[0].output_parsed.totalDistance} •*/}
            {/*📍*/}


            {/*{' '} | {' '}*/}
            {/*https://maps.apple.com/?saddr=55.7558,37.6173&daddr=56.8587,35.9176+to:59.9343,30.3351*/}
            {/*<a*/}
            {/*  target={"_blank"}*/}
            {/*  rel="noreferrer"*/}
            {/*  href={"https://maps.apple.com/"*/}
            {/*    + "?saddr=" + route.places[0].latitude + ',' + route.places[0].longitude*/}
            {/*    + '&daddr=' + (route.places[route.places.length - 1].latitude + 0.0001) + ',' + (route.places[route.places.length - 1].longitude + 0.0001)*/}
            {/*    + '+to:' + route.places.slice(1, -1).map(v => v.latitude + ',' + v.longitude).join("+to:")*/}
            {/*  }*/}
            {/*>*/}
            {/*  Apple Maps*/}
            {/*</a>*/}
            {/*<a*/}
            {/*  target={"_blank"}*/}
            {/*  rel="noreferrer"*/}
            {/*  href={"https://www.google.com/maps/dir/" + actionResult.results[0].output_parsed.waypoints.map(encodeURIComponent).join("/")}*/}
            {/*>*/}
            {/*  Show in Google Maps*/}
            {/*</a>*/}
          </p>
        </div>

        {route.places.map((place, index) => (
          <div
            key={index}
          >
            {index > 0 && (
              <div
                // className="relative border-l-4 border-blue-400 pl-6 mb-8"
                className="relative pl-6 mb-8"
              >
                {/*<div className="absolute -left-[9px] top-1.5 bg-blue-400 rounded-full h-4 w-4"></div>*/}
                <p className="text-sm text-gray-500">
                  {place.transportTypeInSelectedLanguage} {place.distanceFromPreviousPlace} {place.durationFromPreviousPlace}
                </p>
              </div>
            )}

            <div
              key={index}
              className="relative border-l-4 border-blue-400 pl-6"
            >
              <div className="absolute -left-[9px] top-1.5 bg-blue-400 rounded-full h-4 w-4"></div>

              <p className="text-sm text-gray-500 pb-3">
                {/*{index > 0 && index < actionResult.results[0].output_parsed.locations.length - 1 ? `${step.transportTypeInSelectedLanguage} ${step.distance} • ` : ''}*/}

                {/*{index > 0 ? `${place.arrivalTimeTextWithLabel}` : ''}*/}
                {/*{index > 0 && index < route.places.length - 1 ? ` • ` : ''}*/}
                {index > 0 && index < route.places.length - 1 ? ` ⌛ ${place.activityTypeInSelectedLanguage} ${place.activityDuration}` : ''}
                {/*{index > 0 && index < route.places.length - 1 ? ` • ` : ''}*/}
                {/*{index < route.places.length - 1 ? ` ${place.departureTimeTextWithLabel}` : ''}*/}

                {/*{index > 0 ? `${step.arrivalTimeTextWithLabel} • ⌛ ${step.activityTypeInSelectedLanguage} ${step.duration} • ` : ''}*/}
                {/*{step.departureTimeTextWithLabel}*/}
                {/*{step.departureTime} → {step.arrivalTime} • ⌛ {step.duration}*/}
              </p>
              {/*<h1 className="text-3xl font-bold mb-2 text-blue-700">*/}

              {place.website && (
                <Link
                  to={place.website}
                  target="_blank"
                  className="guide-route-read-more"
                >
                  <h2 className="text-lg font-semibold text-blue-800 flex gap-1">
                    {place.name}
                    <ExternalLink className="w-4 h-5" />
                  </h2>

                </Link>
              )}
              {!place.website && (
                <h2 className="text-lg font-semibold text-gray-800">
                  {place.name}
                </h2>
              )}

              <p className="text-sm text-gray-500">
                {place.typeOfAttractionInSelectedLanguage}
              </p>

              {SHOWCOORDS && (
                <p className="text-sm text-blue-600 italic">
                  {place.latitude + "," + place.longitude}
                  <br />
                  distance: {haversine(route.request.coordinates[0], route.request.coordinates[1], place.latitude, place.longitude)}
                </p>
              )}

              <p className="text-gray-700 mt-3 mb-3">{place.descriptionOfAttraction} {place.whatToDoHereLongText}</p>
            </div>
          </div>
        ))}

        <div className="text-left mt-8 guide-route-share-with-friends">
          <p className="text-gray-600 mb-2">Share route</p>
          <ShareButtons route={route} />
        </div>

        {/*<button*/}
        {/*  type="button"*/}
        {/*  className="w-full mt-6 bg-blue-600 text-white py-3 px-4 rounded-xl font-semibold hover:bg-blue-700 transition-all"*/}
        {/*  onClick={event => {*/}
        {/*    window.open('https://www.google.com', '_blank');*/}
        {/*  }}*/}
        {/*>*/}
        {/*  Start route*/}
        {/*</button>*/}

        {/*<div className="">*/}
        {/*  <Link*/}
        {/*    to={M_URI_FULL_ROOT_PATH}*/}
        {/*    className="bg-blue-600 text-white w-full  px-4 py-3 rounded-xl font-semibold hover:bg-blue-700 transform hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-xl"*/}
        {/*  >*/}
        {/*    Start route*/}
        {/*  </Link>*/}
        {/*</div>*/}

        <div className="text-center">
          <Link
            to={mapUrl}
            target="_blank"
            className="guide-route-plan-next-route bg-blue-600 text-white px-16 py-3 rounded-xl font-semibold hover:bg-blue-700 transform hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-xl"
          >
            Start route
          </Link>
        </div>


      </div>
    </>
  );
}

export default RouteView;